import type { OverpassAddress } from "./address.ts"

const URL = (query: string) => `https://overpass-api.de/api/interpreter?data=${encodeURIComponent(query)}`

const QUERY_EACH = (coords: [lat: number, lon: number], radiusMeters: number, limitResults: number, timeout: number = 25) =>
	`[out:json][timeout:${timeout}];
(node["building"]["addr:housenumber"]["addr:street"](around:${radiusMeters},${coords.map(x => x.toFixed(6)).join(',')}););
out ids tags center ${limitResults};
(way["building"]["addr:housenumber"]["addr:street"](around:${radiusMeters},${coords.map(x => x.toFixed(6)).join(',')}););
out ids tags center ${limitResults};
(relation["building"]["addr:housenumber"]["addr:street"](around:${radiusMeters},${coords.map(x => x.toFixed(6)).join(',')}););
out ids tags center ${limitResults};
`

const QUERY_ALL = (coords: [lat: number, lon: number], radiusMeters: number, limitResults: number, timeout: number = 25) =>
	`[out:json][timeout:${timeout}];
(
node["building"]["addr:housenumber"]["addr:street"](around:${radiusMeters},${coords.map(x => x.toFixed(6)).join(',')});
way["building"]["addr:housenumber"]["addr:street"](around:${radiusMeters},${coords.map(x => x.toFixed(6)).join(',')});
relation["building"]["addr:housenumber"]["addr:street"](around:${radiusMeters},${coords.map(x => x.toFixed(6)).join(',')});
);
out ids tags center ${limitResults};
`

type OverpassResponse = {
	version: number
	generator: string
	osm3s: {
		timestamp_osm_base: string
	}
	elements: OverpassAddress[]
}

type Query = {
	type: 'each' | 'all'
	coords: [lat: number, lon: number]
	radiusMeters: number
	limitResults: number
	timeout?: number
}

const queryToString = (query: Query) =>
	(query.type === 'each' ? QUERY_EACH : QUERY_ALL)
	(query.coords, query.radiusMeters, query.limitResults, query.timeout)

export async function loadOverpassData(query: Query): Promise<OverpassResponse>
{
	const url = URL(queryToString(query))
	const response = await fetch(url)
	if (!response.ok)
		throw new Error(`HTTP error! status: ${response.status}`)

	return response.json()
}
